import { Button, CustomText } from '@vfit/shared/atoms';
import { AppMobile } from '@vfit/shared/data-access';
import { fonts } from '@vfit/shared/themes';
import {
  MultiSelectionFilterContainer,
  InputContainer,
  SelectInput,
  SearchButton,
} from './searchElement.style';
import { ISearchProduct } from './searchElement.models';
import { SelectV2 } from '@vfit/shared/components';

const SearchElement = ({
  title,
  labelSelect,
  productsListItems,
  submitVariant,
  selectedProductItem,
  handleSelectProduct,
  clearable,
  customAction,
}: ISearchProduct) => (
  <MultiSelectionFilterContainer>
    <CustomText
      text={title || ''}
      textAlign="center"
      fontFamily={fonts.light}
      size={36}
      lineHeight={50}
    />
    <InputContainer>
      <SelectInput>
        <SelectV2
          label={labelSelect || 'Element'}
          variant="mva:animated"
          items={productsListItems}
          editable
          onChange={(e) => handleSelectProduct(e)}
          clearable={clearable}
        />
      </SelectInput>
      {customAction?.title && (
        <SearchButton>
          <Button
            onClick={customAction.onClick}
            variant={submitVariant || 'primary'}
            disabled={!productsListItems?.includes(selectedProductItem || '')}
            aria-label={customAction?.title}
          >
            <span className={`${AppMobile.checkIsApp() ? 'capitalize-first' : ''}`}>
              {customAction?.title}
            </span>
          </Button>
        </SearchButton>
      )}
    </InputContainer>
  </MultiSelectionFilterContainer>
);
export default SearchElement;

